import React from "react";
import { Input, InputProps } from "antd";
import { SearchContext } from "./context";
import classNames from "classnames";

const BaseInput = React.forwardRef<Input, InputProps>((props, ref) => {
    const { onPressEnter = () => {} } = React.useContext(SearchContext) || {};
    const hasValue = props.value;

    function handleKeyPress(evt: React.KeyboardEvent) {
        if (evt.code === "NumpadEnter" || evt.code === "Enter") {
            onPressEnter();
        }
    }

    return (
        <Input
            style={{ width: 110, fontSize: 13 }}
            size="small"
            onKeyPress={handleKeyPress}
            {...props}
            className={classNames(
                {
                    "has-value": hasValue,
                },
                props.className,
            )}
            ref={ref}
        />
    );
});

export default React.memo(BaseInput);
